import src from "IMAGE";
export default { src, width: 629, height: 302, blurWidth: 0, blurHeight: 0};
